<template>
  <svg
    role="img"
    aria-label="read-small icon"
    class="read-small-icon o-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
  >
    <title>Read</title>

    <g clip-path="url(#clip0_5615_4274)">
      <path
        d="M11.9 0.100098H4.87001C3.76001 0.100098 2.87001 1.0001 2.87001 2.1101V2.9501H2.10001C0.990006 2.9501 0.100006 3.8401 0.100006 4.9401V11.9001C0.100006 13.0001 1.00001 13.9001 2.10001 13.9001H11.89C12.99 13.9001 13.89 13.0001 13.89 11.9001V2.1101C13.89 1.0101 12.99 0.110098 11.89 0.110098L11.9 0.100098ZM2.87001 12.4001H2.11001C1.83001 12.4001 1.61001 12.1801 1.61001 11.9001V4.9401C1.61001 4.6701 1.83001 4.4401 2.11001 4.4401H2.88001V12.4001H2.87001ZM12.4 11.9001C12.4 12.1801 12.17 12.4001 11.9 12.4001H4.87001C4.59001 12.4001 4.37001 12.1701 4.37001 11.9001V2.1101C4.37001 1.8301 4.60001 1.6101 4.87001 1.6101H11.9C12.18 1.6101 12.4 1.8401 12.4 2.1101V11.9001Z"
        fill="currentColor"
      />
      <path
        d="M10.59 4.3501H7.39C6.98 4.3501 6.64 4.0101 6.64 3.6001C6.64 3.1901 6.98 2.8501 7.39 2.8501H10.59C11 2.8501 11.34 3.1901 11.34 3.6001C11.34 4.0101 11 4.3501 10.59 4.3501Z"
        fill="currentColor"
      />
      <path
        d="M10.59 7.75H6.33C5.92 7.75 5.58 7.41 5.58 7C5.58 6.59 5.92 6.25 6.33 6.25H10.59C11 6.25 11.34 6.59 11.34 7C11.34 7.41 11 7.75 10.59 7.75Z"
        fill="currentColor"
      />
      <path
        d="M10.59 11.1499H6.33C5.92 11.1499 5.58 10.8099 5.58 10.3999C5.58 9.9899 5.92 9.6499 6.33 9.6499H10.59C11 9.6499 11.34 9.9899 11.34 10.3999C11.34 10.8099 11 11.1499 10.59 11.1499Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5615_4274">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<style lang="scss" scoped>
.read-small-icon {
  height: 14px;
  width: 14px;
}
</style>
